import { render, staticRenderFns } from "./Descriptions.vue?vue&type=template&id=51933a48"
import script from "./Descriptions.vue?vue&type=script&lang=js"
export * from "./Descriptions.vue?vue&type=script&lang=js"
import style0 from "./Descriptions.vue?vue&type=style&index=0&id=51933a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports